import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TodayService } from "../../../_services/theme/today.service";
import { ThemeService } from "app/_services/theme/theme.service";
declare let toastr: any;

@Component({
    selector: 'app-theme-custom-upload',
    templateUrl: './theme-custom-upload.component.html',
    styleUrls: ['./theme-custom-upload.component.scss']
})
export class ThemeCustomUploadComponent implements OnInit {
    public uploadList = [];
    public isUploading = false;
    public forceChk = false;
    @Input()
    public active = false;
    @Output()
    public activeChange: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    public onSuccess: EventEmitter<any> = new EventEmitter<any>();
    constructor(
        private themeService: ThemeService
    ) { }

    ngOnInit(): void {
    }

    successCsv({ response }) {
        console.log(response, 'res')
        this.uploadList = this.uploadList.concat(response);
        this.forceChk = true;
    }

    upload() {
        this.isUploading = true;
        this.themeService.uploadCustomThemeView(this.uploadList)
            .then(r => {
                toastr.success('업로드가 완료되었습니다.');
                this.onSuccess.emit();
                this.close();
            })
            .catch(e => {
                toastr.error(e.error.message);
            })
            .finally(() => {
                this.isUploading = false;
            })
    }

    close() {
        this.activeChange.emit(false);
    }

    deleteItem(index: number) {
        this.uploadList = this.uploadList.filter((v, i) => i !== index);
    }

    addItem() {
        this.uploadList = [...this.uploadList, {
            customTitle: '',
            title: '',
            'thumbnail_image': '',
            'label_text': '',
            'label_color': '',
            'link': ''
        }];
    }

    download() {
        const url = `${window.location.protocol}//${window.location.host}/api/upload/example/download/csv?keys=customTitle,title,thumbnail_image,label_text,label_color,link`;
        window.open(url, 'blank');
    }

}
